const FILE_MARKER = '__bnsFile';
const FILE_LIST_MARKER = '__bnsFileList';

export const IMAGE_SPEC_TITLES = new Set(['조절기 이미지', '제어기 이미지']);
export const FIRMWARE_SPEC_TITLE = '펌웨어 파일';
export const WIRING_DIAGRAM_SPEC_TITLE = '결선도 파일';
const NOTE_SPEC_TITLE = '비고';

export const isImageSpecTitle = (title = '') => IMAGE_SPEC_TITLES.has(title);
export const isFirmwareSpecTitle = (title = '') => title === FIRMWARE_SPEC_TITLE;
export const isWiringDiagramSpecTitle = (title = '') => title === WIRING_DIAGRAM_SPEC_TITLE;
export const isUploadSpecTitle = (title = '') => (
    isImageSpecTitle(title) || isFirmwareSpecTitle(title) || isWiringDiagramSpecTitle(title)
);

/** 구 데이터에 결선도 행이 없으면 비고 앞에 삽입 */
export const ensureWiringDiagramSpecInSpecs = (specs) => {
    if (!Array.isArray(specs)) {
        return specs;
    }
    if (specs.some((s) => String(s?.title || '').trim() === WIRING_DIAGRAM_SPEC_TITLE)) {
        return specs;
    }
    const noteIdx = specs.findIndex((s) => String(s?.title || '').trim() === NOTE_SPEC_TITLE);
    const row = { title: WIRING_DIAGRAM_SPEC_TITLE, fullWidth: true, details: '' };
    if (noteIdx === -1) {
        return [...specs, row];
    }
    const next = [...specs];
    next.splice(noteIdx, 0, row);
    return next;
};

export const parseSpecFileValue = (value) => {
    if (!value || typeof value !== 'string') {
        return null;
    }

    try {
        const parsed = JSON.parse(value);
        if (parsed && parsed[FILE_MARKER] === true) {
            return parsed;
        }
        return null;
    } catch (error) {
        return null;
    }
};

export const createSpecFileValue = ({ kind, name, mimeType, dataUrl, description }) => JSON.stringify({
    [FILE_MARKER]: true,
    kind,
    name: name || '',
    mimeType: mimeType || '',
    dataUrl: dataUrl || '',
    description: description || '',
});

export const parseSpecFileListValue = (value) => {
    if (!value || typeof value !== 'string') {
        return [];
    }

    try {
        const parsed = JSON.parse(value);
        if (parsed && parsed[FILE_LIST_MARKER] === true && Array.isArray(parsed.files)) {
            return parsed.files;
        }
        if (parsed && parsed[FILE_MARKER] === true) {
            return [parsed];
        }
        return [];
    } catch (error) {
        return [];
    }
};

export const createSpecFileListValue = ({ files }) => JSON.stringify({
    [FILE_LIST_MARKER]: true,
    files: Array.isArray(files) ? files : [],
});
